import digitalData from 'digital-data';
import {
  ATC,
  MAGIC_APRON,
  MAGIC_APRON_BOT_SUBMIT_CLICK_EVENT,
  MAGIC_APRON_ASSISTANT_SUBMIT_CLICK_EVENT,
  NOT_APPLICABLE,
  PRODUCT_POD,
  RECOMMENDATION_EVENTNAME,
  RECS_CART_ADDITION_INFO,
  SECTION,
  STASH,
} from '../constants';

export const magicApronBot = () => {
  window.LIFE_CYCLE_EVENT_BUS.on('magic-apron-bot.submit-click', ({ output = {} }) => {
    const { sessionID = '', actionID = '', question = '' } = output;
    const thdAnalyticsEvent = {
      category: {
        primaryCategory: MAGIC_APRON
      },
      eventInfo: {
        eventName: MAGIC_APRON_BOT_SUBMIT_CLICK_EVENT
      },
      maSessionID: sessionID,
      maActionID: actionID,
      question,
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(thdAnalyticsEvent);
  });
};

export const magicApronAssistant = () => {
  window.LIFE_CYCLE_EVENT_BUS.on('magic-apron-assistant.product-pod-click', ({ output = {} }) => {
    const { displayPosition = '' } = output;
    const pageType = digitalData?.page?.pageInfo.pageType;

    const thdAnalyticsEvent = {
      category: {
        primaryCategory: STASH
      },
      eventInfo: {
        eventName: RECOMMENDATION_EVENTNAME
      },
      eventMode: STASH,
      stash: {
        recommendation: {
          anchorProductSku: 'n/a',
          displayPosition,
          featureVersion: 'n/a',
          interval: 'n/a',
          pageType,
          recommendationType: 'maa best-matches',
          recommendationVersion: '', // Set value to the "version" returned in API response.
          strategy: '', // Set value to the "version" returned in API response.
        },
      },
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(thdAnalyticsEvent);
  });

  window.LIFE_CYCLE_EVENT_BUS.on('magic-apron-assistant.product-pod-atc-click', ({ output = {} }) => {
    const { items = [] } = output;
    const pageType = digitalData?.page?.pageInfo.pageType;

    const thdAnalyticsEvent = {
      category: {
        primaryCategory: STASH
      },
      eventInfo: {
        eventName: RECS_CART_ADDITION_INFO
      },
      eventMode: STASH,
      stash: {
        component: PRODUCT_POD,
        pageType,
        section: SECTION,
        sharedSection: NOT_APPLICABLE,
        target: ATC,
        item: items,
        recommendation: {
          recommendationType: 'maa best-matches',
          pageType,
          anchorProductSku: 'n/a',
          // Strategy value from dynamic recs API response (response will contain multiple strategy values,
          // choose the strategy value for the OMSID that was clicked on). If NOT available, set to "n/a"
          strategy: 'n/a',
          recommendationVersion: 'n/a', // Add version value from the API response. If not available, set to "n/a"
          featureVersion: 'n/a',
          interval: 'n/a',
          sponsoredProduct: 'n/a', // For Sponsored Product = "sp", for non-SP = "n/a"
        }
      },
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(thdAnalyticsEvent);
  });

  window.LIFE_CYCLE_EVENT_BUS.on('magic-apron-assistant.fab-click', ({ output = {} }) => {
    const thdAnalyticsEvent = {
      category: {
        primaryCategory: 'magic apron'
      },
      eventInfo: {
        eventName: 'maa fab click'
      },
      maSessionID: output?.sessionID || '',
      maActionID: output?.actionID || ''
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(thdAnalyticsEvent);
  });

  window.LIFE_CYCLE_EVENT_BUS.on('magic-apron-assistant.submit-click', ({ output = {} }) => {
    const { sessionID = '', question = '', actionID = '' } = output;
    const thdAnalyticsEvent = {
      category: {
        primaryCategory: MAGIC_APRON
      },
      eventInfo: {
        eventName: MAGIC_APRON_ASSISTANT_SUBMIT_CLICK_EVENT
      },
      maSessionID: sessionID,
      question,
      maActionID: actionID

    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(thdAnalyticsEvent);
  });
};